import createApiRequest from '@/lib/axios/createApiRequest';
import type OpportunityConfidenceLevel from '@/types/api/OpportunityConfidenceLevel';
import type PostOpportunityConfidenceLevel from '@/types/api/PostOpportunityConfidenceLevel';

export default function postOpportunityConfidenceLevel(
  data: PostOpportunityConfidenceLevel,
) {
  return createApiRequest<{
    opportunityConfidenceLevel: OpportunityConfidenceLevel;
  }>({
    data,
    method: 'post',
    path: 'opportunity-confidence-levels',
    throwErrors: true,
  });
}
